var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-entrepreneur-video-decorative-item",class:("c-entrepreneur-video-decorative-item--" + (_vm.icon.className))},[_c('icon',{staticClass:"c-entrepreneur-video-decorative-item__icon ",attrs:{"icon":_vm.icon.iconName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }